import React, { useEffect, useState } from 'react';
import { PhoneInputProps } from '../../../../interfaces/interfaceSteps';
import { Input, CheckboxComponent } from '@gs/fe-storybook-gasco';
import Bandera from '../../../../assets/images/bandera-chile.png';
import './PhoneInput.css';

const PhoneInput: React.FC<PhoneInputProps> = ({
  value,
  onChange,
  placeholders,
  onCheckboxChange,
  isCheckboxChecked,
}) => {
  const [phone, setPhone] = useState<string>('');
  const [phoneError, setPhoneError] = useState<string | null>(null);
  const [isValid, setIsValid] = useState<boolean>(false);
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [checkboxValue, setCheckboxValue] = useState<boolean>(
    isCheckboxChecked || false
  );
  const privacyPolicyUrl = process.env.REACT_APP_PRIVACY_POLICY_URL;

  useEffect(() => {
    setPhone(typeof value === 'string' ? value : value[0] || '');
  }, [value]);

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    if (newValue.length <= 9) {
      setPhone(newValue);
      onChange(newValue);
      validatePhone(newValue, false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!/[0-9]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
    const inputElement = e.target as HTMLInputElement;
    inputElement.value = inputElement.value.replace(/[^0-9]/g, '');
  };

  const validatePhone = (
    phoneNumber: string = phone,
    showError: boolean = true
  ) => {
    if (phoneNumber.length === 0) {
      setIsValid(false);
      if (showError) {
        setPhoneError(null);
      }
    } else if (phoneNumber.length < 9) {
      setIsValid(false);
      if (showError) {
        setPhoneError(
          'El formato no es válido. El número de teléfono debe tener 9 dígitos.'
        );
      }
    } else if (phoneNumber[0] !== '9') {
      setIsValid(false);
      if (showError) {
        setPhoneError(
          'El formato no es válido. Recuerda que debes anteponer un 9 antes del teléfono.'
        );
      }
    } else {
      setIsValid(true);
      setPhoneError(null);
    }
  };

  const handleBlur = () => {
    validatePhone(phone, true);
    setIsFocused(false);
  };

  const handleFocusPhone = () => {
    setIsFocused(true);
    if (phoneError) {
      setIsFocused(false);
    }
  };

  const handleCheckboxChange = (newValue: boolean) => {
    setCheckboxValue(newValue);
    onCheckboxChange(newValue);
  };

  return (
    <>
      <div className="phone-input" id="page-phone" data-page-id="numero">
        <div className="country-code-wrapper">
          <img src={Bandera} alt="Chile Flag" className="flag-icon" />
          <label
            className={`floating-label-top ${
              isFocused || phone || phoneError ? "filled" : ""
            } ${phoneError ? "error" : ""}`}
          >
            Área
          </label>
          <Input
            id="flagInput"
            name="flag"
            value="+56"
            disabled
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            haveError={!!phoneError}
            classNameInput={`country-code ${
              isValid || isFocused ? "valid" : ""
            } ${phoneError && isFocused ? "error" : ""}`}
          />
        </div>
        <div className="phone-container">
          <label
            className={`floating-label-top ${
              isFocused || phone || phoneError ? "filled" : ""
            } ${phoneError ? "error" : ""}`}
          >
            Número de teléfono actual
          </label>
          <Input
            id="numero_numero"
            name="phone"
            type="number"
            inputMode="numeric"
            placeholder={placeholders.phone}
            value={phone}
            onKeyPress={handleKeyPress}
            onChange={handlePhoneChange}
            onBlur={handleBlur}
            onFocus={handleFocusPhone}
            onInput={handleInput}
            maxLength={9}
            haveError={!!phoneError}
            error={phoneError || ""}
            classNameInput={`phone-number ${phoneError ? "error" : ""} ${
              isValid || (isFocused && !phoneError) ? "valid" : ""
            }`}
            classNameError="error-message2"
          />
          <label
            className={`floating-label-bottom ${
              isFocused || phone ? "filled" : ""
            }  ${phoneError ? "error" : ""}`}
          >
            Ejemplo: 939393939
          </label>
        </div>
      </div>
      <div className="privacy-container">
        <CheckboxComponent
          value={checkboxValue}
          onChange={handleCheckboxChange}
          disabled={false}
          isAnimated={true}
        />
        <p className="privacy-text">
          He leído y acepto las{" "}
          <a
            href={privacyPolicyUrl}
            className="privacy-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            políticas de privacidad
          </a>
        </p>
      </div>
    </>
  );
};

export default PhoneInput;
